import { render, staticRenderFns } from "./BiotechFooter.vue?vue&type=template&id=84d057e2&scoped=true"
import script from "./BiotechFooter.vue?vue&type=script&lang=js"
export * from "./BiotechFooter.vue?vue&type=script&lang=js"
import style0 from "./BiotechFooter.vue?vue&type=style&index=0&id=84d057e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d057e2",
  null
  
)

export default component.exports